(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/collections/suspensionhistory.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/collections/suspensionhistory.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.collections.SuspensionHistory = Backbone.Collection.extend({
    model: svs.spelpaus.models.Suspension,
    comparator: 'ended'
  });
})(Backbone, _, svs);

 })(window);